var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationsIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "220px",
    height: "153px",
    viewBox: "0 0 220 153",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "notifications_illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iPhone-8-Copy-39",
    transform: "translate(-79.000000, -170.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notifications_illustration",
    transform: "translate(79.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.6937748,103.272359 C63.4811761,105.446619 63.4296982,109.000491 65.5783901,111.238149 L101.301083,148.276447 C102.350394,149.364343 103.791464,149.985125 105.301488,150 C106.811513,150.014347 108.264283,149.421565 109.334375,148.354176 L218.340206,39.6281539 C219.546087,38.4250583 220.145055,36.7407273 219.970087,35.0448428 C219.795119,33.3489584 218.864933,31.8229536 217.438914,30.8923604 L174.575587,2.92471251 C172.36653,1.46838545 169.441943,1.75676494 167.558721,3.61661199 L65.6937748,103.272359 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.08956,32 C218.87371,32.331393 218.623739,32.6392632 218.343741,32.9185708 L109.825985,143.268514 C108.758175,144.331759 107.3085,144.922239 105.801694,144.907685 C104.294888,144.893131 102.856889,144.274759 101.809815,143.191087 L65.3960077,104.762059 C65.1479171,104.504253 64.9250908,104.223275 64.7305815,103.922976 C63.3341855,106.071375 64.0563473,108.472879 65.9075081,110.388644 L101.554065,147.283139 C102.601139,148.366811 104.039138,148.985183 105.545944,149 C107.05275,149.014291 108.502424,148.423811 109.570235,147.360566 L218.343741,39.0566639 C220.230466,37.1771052 220.541686,34.232452 219.08956,32 L219.08956,32 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.289109,32.3912952 L203.854326,29.54477 C204.816216,31.2702588 204.469276,33.4355893 203.017257,34.7691034 C201.565238,36.1026174 199.391603,36.2521477 197.772888,35.1298778 L169.074775,15.2675805 C167.74379,14.3479028 167.050104,12.7447823 167.28756,11.13729 C167.525016,9.52979779 168.652056,8.1992516 170.191275,7.70926191 L167.906444,6.24272791 C167.295534,5.85060086 166.495584,5.9410786 165.986338,6.4599002 L69.4438176,101.971461 C69.1528376,102.267914 68.9929171,102.669979 69,103.086679 C69.0075647,103.50338 69.1815138,103.899497 69.4827292,104.185403 L104.544616,138.578402 C105.148889,139.151944 106.096394,139.138695 106.684611,138.548479 L208.547907,34.7925128 C208.878338,34.460958 209.041344,33.9962912 208.99102,33.5293694 C208.940696,33.0624475 208.682487,32.6437894 208.289109,32.3912952 L208.289109,32.3912952 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E6E6E6",
    points: "98 81.7358092 127.598341 110 198 39.5534924 162.270624 16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.328384,57.6809713 C194.773133,58.1063429 195.472888,58.1063429 195.917637,57.6809713 L202.671616,50.9117589 C203.109461,50.4715331 203.109461,49.7592524 202.671616,49.3190266 C202.226866,48.8936578 201.527113,48.8936578 201.082363,49.3190266 L194.328384,56.0882417 C193.890539,56.5284666 193.890539,57.2407464 194.328384,57.6809713 L194.328384,57.6809713 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.3285,67.6715986 C184.767792,68.1094671 185.478512,68.1094671 185.917805,67.6715986 L192.672009,60.9173186 C193.109785,60.4782511 193.109264,59.7675849 192.670844,59.32916 C192.232424,58.8907352 191.521766,58.8902139 191.082703,59.3279951 L184.3285,66.0822751 C183.8905,66.5215168 183.8905,67.2323569 184.3285,67.6715986 L184.3285,67.6715986 Z",
    id: "Path",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#951B81",
    cx: 98,
    cy: 106,
    r: 7
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#3F3D56",
    points: "165.898238 150 18 150 18 149 166 149"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    x: 76,
    y: 46,
    width: 73,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    x: 76,
    y: 22,
    width: 73,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    x: 76,
    y: 0,
    width: 73,
    height: 15
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "77 13 147 13 147 1 77 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "77 36 147 36 147 24 77 24"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "77 59 147 59 147 47 77 47"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FEC532",
    cx: 82.5,
    cy: 7.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FEC532",
    x: 93,
    y: 5,
    width: 43,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FEC532",
    x: 93,
    y: 7,
    width: 43,
    height: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CCCCCC",
    cx: 82.5,
    cy: 29.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 93,
    y: 29,
    width: 43,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 93,
    y: 31,
    width: 43,
    height: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#CCCCCC",
    cx: 82.5,
    cy: 53.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 93,
    y: 51,
    width: 43,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#CCCCCC",
    x: 93,
    y: 54,
    width: 43,
    height: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.32351719,151.540852 L5.23495179,151.772095 C6.7447601,152.709831 8.51685031,153.062837 10.4794942,152.990979 C11.0369304,152.973775 11.5438394,152.653766 11.8117757,152.149915 L11.8117757,152.149915 C12.043383,151.709558 12.0622558,151.18309 11.8628082,150.726334 C11.6633607,150.269578 11.2684392,149.934856 10.7949323,149.821238 L9.34254555,149.472752 L5.8379338,145.941792 L3.72367673,142 L0.652549721,142.362829 L0.0132077499,147.369632 L0.0132077499,147.369632 C-0.155383485,149.451991 1.30892436,151.29712 3.32351719,151.540852 L3.32351719,151.540852 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.014543,149.658633 L34.9611963,150.123651 C36.412045,151.259164 38.2008474,151.831305 40.2352052,151.9941 C40.8126408,152.043606 41.3727195,151.778964 41.7072268,151.298559 L41.7072268,151.298559 C41.9969309,150.878384 42.0769194,150.34503 41.9235172,149.85636 C41.7701151,149.367691 41.4008944,148.979681 40.9251369,148.807175 L39.4658476,148.27806 L36.2537328,144.264459 L34.524141,140 L31.3120208,140 L30.0765935,145.017001 L30.0765935,145.017001 C29.6632283,147.115305 30.9628251,149.168523 33.014543,149.658633 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3269029,140.447699 L30.85187,140.983264 L25.3720116,113.267784 L15.8824896,97.0669456 L4.3881576,144.196653 L0.11119399,145 C0.590782337,118.459451 -1.75002407,85.0461327 3.58622693,81 L26.8422166,83.6778243 L37,110.991632 L34.3269029,140.447699 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFB8B8",
    cx: 18,
    cy: 32,
    r: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFB8B8",
    points: "6 45.3499867 15.599897 47 18 38.1998407 11.0666552 36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,82.5555556 L28,85 C25.9156007,77.7314351 24.00586,70.4884331 25.5625,63.2716049 C27.5392332,56.8286973 25.6312836,52.9972907 20.4166667,49.962963 L16.8958333,42.0864198 L7.41667974,41 L7.41667974,41 C4.90642571,45.0475606 3.87958234,49.8452652 4.51245157,54.5693809 C5.8631146,64.8423107 5.49837087,74.3750061 2,82.5555556 Z",
    id: "Path",
    fill: "#18683E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1650295,24.1199123 C17.8898133,23.9331903 21.0401543,23.8816708 21.434661,24.5935963 C24.2562242,24.4626902 26.7135789,25.439046 27.8470289,27.7110895 C28.0429873,28.1093258 28.0510526,28.5732096 27.8690547,28.9779121 C27.6870567,29.3826146 27.333692,29.686561 26.9040491,29.8079608 C25.4726793,30.2173327 23.2909539,30.7237687 21.6990912,30.5620462 C18.3930482,34.417641 19.7840657,41.4498355 22.9930777,45.5581147 L20.0932797,46.1477321 L14.5906946,38.5463635 L16.3269831,46.9135455 L9.63072636,48 L7.29521685,37.3667594 C6.80417216,34.8427756 6.92707011,32.2390132 7.65371015,29.7715847 C7.73133651,29.5224035 7.82498304,29.2784138 7.93407389,29.0411159 C9.24818389,26.20606 12.0255854,24.3158315 15.1650295,24.1199123 L15.1650295,24.1199123 Z",
    id: "Path",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3187681,90.1909403 L19.1389667,96.4755455 C19.087547,98.2727862 20.4358741,99.8040596 22.2273436,99.9829656 L22.2273436,99.9829656 C23.350054,100.095085 24.4562045,99.6488182 25.1858832,98.7893685 C25.915562,97.9299187 26.1754963,96.7671471 25.8811105,95.6793883 L24.4690044,90.4616451 L20.40303,68.2642775 L20.6740955,55.2706995 L12,55 L13.6263981,69.6177752 L19.3187681,90.1909403 Z",
    id: "Path",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,57 C13.2204803,55.8171445 16.7795197,55.8171445 20,57 L19.4444444,46.2857117 C19.4444444,43.9187795 17.4546017,42 15,42 L15,42 C12.545409,42 10.5555663,43.9187795 10.5555663,46.2857117 L10,57 Z",
    id: "Path",
    fill: "#18683E"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIllustration);
export default __webpack_public_path__ + "static/media/notifications_illustration.425da6868aebaf2b387f46a9e195687f.svg";
export { ForwardRef as ReactComponent };